export default __webpack_public_path__ + "static/media/redirect.fc4ba8ad.svg";